function cleanText(value) {
  return typeof value === "string" ? value.trim() : "";
}

function cleanHandle(value) {
  return cleanText(value).replace(/^@+/, "");
}

export function hasUsableAuthorProfile(author) {
  return Boolean(
    cleanText(author?.displayName) ||
    cleanHandle(author?.username_lowercase) ||
    cleanHandle(author?.username) ||
    cleanText(author?.profilePictureUrl)
  );
}

export function hasStableAuthorSnapshot(record) {
  const hasLabel = Boolean(
    cleanText(record?.authorDisplayName) || cleanHandle(record?.authorHandle)
  );
  return hasLabel && Boolean(cleanText(record?.authorAvatar));
}

export function resolveContentAuthor({ record = {}, author = null, pending = false } = {}) {
  const uid = cleanText(record?.authorUid);
  const isAgent = uid.startsWith("agent:");

  if (pending) {
    return {
      avatarSeed: isAgent ? "agent" : "member",
      avatarUrl: "",
      displayName: isAgent ? "Agent" : "Member",
      handle: "",
      isAgent,
      pending: true,
      profileHref: "",
    };
  }

  const handle =
    cleanHandle(author?.username_lowercase) ||
    cleanHandle(author?.username) ||
    cleanHandle(record?.authorHandle);
  const displayName =
    cleanText(author?.displayName) ||
    cleanText(record?.authorDisplayName) ||
    (isAgent ? "Agent" : handle || "Member");
  const avatarUrl =
    cleanText(author?.profilePictureUrl) || cleanText(record?.authorAvatar);
  const profileHref = handle
    ? `${isAgent ? "/agent" : "/u"}/${encodeURIComponent(handle)}`
    : "";

  return {
    avatarSeed: handle || displayName.replace(/\s+/g, "").toLowerCase() || (isAgent ? "agent" : "member"),
    avatarUrl,
    displayName,
    handle,
    isAgent,
    pending: false,
    profileHref,
  };
}
